import {
	Card,
	DatePicker,
	Form,
	Select,
	Space,
	Tabs,
	Typography,
	Button,
	notification,
} from "antd";
import { useTable } from "@refinedev/antd";
import { useEffect, useState } from "react";
import UserSearchSelect from "../../components/UserSearchSelect";
import { FilterOutlined } from "@ant-design/icons";
import { useUpdate } from "@refinedev/core";
import { ReportReviewList } from "../components/ReportReviewList";

const { RangePicker } = DatePicker;
const { Title } = Typography;

export const ReportContentList = () => {
	const [activeTab, setActiveTab] = useState("pending");

	const {
		mutate: submitAction,
		variables,
		isLoading: submitActionLoading,
	} = useUpdate({
		resource: "report",
		mutationMode: "optimistic",
		mutationOptions: {
			retry: 3,
			onSuccess: (data) => {
				notification.success({
					message: "Success",
					description: data?.data?.message,
				});
			},
			onError: (error) => {
				console.error("Error updating user status:", error);
			},
		},
	});

	const { tableProps, searchFormProps, setFilters } = useTable({
		onSearch: (values: any) => {
			return [
				{
					field: "hasText",
					operator: "eq",
					value: "true",
				},
				{
					field: "entityType",
					operator: "eq",
					value: values.entityType,
				},
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
				{
					field: "reporterType",
					operator: "eq",
					value: values.reporterType,
				},
				{
					field: "from",
					operator: "eq",
					value: values.dateRange
						? values.dateRange[0].startOf("day").toISOString()
						: undefined,
				},
				{
					field: "to",
					operator: "eq",
					value: values.dateRange
						? values.dateRange[1].startOf("day").toISOString()
						: undefined,
				},
				{
					field: "reporterID",
					operator: "eq",
					value: values.reporterID,
				},
				{
					field: "entityCreatorID",
					operator: "eq",
					value: values.entityCreatorID,
				},
				{
					field: "entityType",
					operator: "eq",
					value: values.entityType,
				},
			];
		},
		syncWithLocation: true,
		filters: {
			initial: [
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
				{
					field: "hasText",
					operator: "eq",
					value: "true",
				},
			],
		},
		queryOptions: {
			keepPreviousData: false,
			cacheTime: 0, // Changed to milliseconds
		},
		resource: "report",
	});

	useEffect(() => {
		activeTab === "pending" &&
			setFilters([
				{
					field: "isReviewed",
					operator: "eq",
					value: "false",
				},
			]);
		activeTab === "reviewed" &&
			setFilters([
				{
					field: "isReviewed",
					operator: "eq",
					value: "true",
				},
			]);
	}, [activeTab]);

	return (
		<div style={{ padding: "20px" }}>
			<Title level={3}>Content Reports Management</Title>
			<div style={{ padding: "20px" }}>
				<div
					style={{
						display: "flex",
						alignItems: "start",
						gap: 24,
						marginTop: "20px",
					}}
				>
					<Card style={{ width: 300 }}>
						<Title level={3}>Filter content reports</Title>
						<hr
							style={{
								marginLeft: -25,
								border: "0.2px solid #424242",
								width: 300,
							}}
						/>
						<Form
							{...searchFormProps}
							layout="vertical"
							style={{ marginTop: 20 }}
						>
							<Form.Item name="entityCreatorID" label="User">
								<UserSearchSelect
									onChange={(value: any) =>
										searchFormProps.form?.setFieldValue(
											"entityCreatorID",
											value,
										)
									}
									userType={
										searchFormProps.form?.getFieldValue("userType") || []
									}
								/>
							</Form.Item>
							<Form.Item name="reporterID" label="Reporter">
								<UserSearchSelect
									onChange={(value: any) =>
										searchFormProps.form?.setFieldValue("reporterID", value)
									}
									userType={
										searchFormProps.form?.getFieldValue("userType") || []
									}
								/>
							</Form.Item>
							<Form.Item name="entityType" label="Entity Type">
								<Select
									placeholder="Select Entity Type"
									allowClear
									options={[
										{ value: "stream:feeds:v2:activity", label: "Activity" },
										{ value: "stream:feeds:v2:reaction", label: "Reaction" },
										{ value: "stream:chat:v1:message", label: "Message" },
									]}
								/>
							</Form.Item>
							<Form.Item name="reporterType" label="Reporter Type">
								<Select
									placeholder="Select Reporter Type"
									allowClear
									options={[
										{ value: "automod", label: "Automod" },
										{ value: "moderator", label: "Moderator" },
										{ value: "user", label: "User" },
									]}
								/>
							</Form.Item>
							<Form.Item name="dateRange" label="Date">
								<RangePicker />
							</Form.Item>
							<Space style={{ display: "flex", justifyContent: "flex-end" }}>
								<Form.Item>
									<Button
										type="primary"
										icon={<FilterOutlined />}
										htmlType="submit"
									>
										Search
									</Button>
								</Form.Item>
							</Space>
						</Form>
					</Card>

					<div style={{ flex: 1, minWidth: 0 }}>
						<Tabs
							activeKey={activeTab}
							onChange={setActiveTab}
							type="card"
							destroyInactiveTabPane={true}
							items={[
								{
									key: "pending",
									label: "Pending Reports",
									children: (
										<ReportReviewList tableProps={tableProps} showReportType={true} actionButtonsToShow={{
											markAsReviewed: true,
											globalBan: true,
											channelBan: true,
											channelBan24H: true,
											globalBan24H: true,
											unBan: true,
											delete: true,
											showButton: true,
										}}/>
									),
								},
								{
									key: "reviewed",
									label: "Reviewed Reports",
									children: (
										<ReportReviewList tableProps={tableProps} showReportType={true} showReviewdBy={true} 
                                        actionButtonsToShow={{
											globalBan: true,
											channelBan: true,
											channelBan24H: true,
											globalBan24H: true,
											unBan: true,
											delete: true,
											showButton: true,
										}}/>
									),
								},
							]}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
